export async function handleLoadMore(getLatest, limit, dataKey) {
  if (this.loading) return;
  this.loading = true;

  const cursor = this[dataKey][this[dataKey].length - 1]._fl_meta_.createdDate;

  let next = await getLatest({
    limit,
    startAfter: cursor
  });

  if (next !== null) {
    next = Object.values(next);
    this[dataKey].push(...next);
  }

  if (next === null || next.length < limit) {
    this.end = true;
  }

  this.loading = false;
}
